/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    FETCH_AGGREGATE_FAILURE,
    FETCH_AGGREGATE_START,
    FETCH_AGGREGATE_SUCCESS,
} from '../constants/types';
import { makeAsyncReducer } from '../utils/async_utils';

export const fetchAggregate = makeAsyncReducer(
    {
        startType: FETCH_AGGREGATE_START,
        successType: FETCH_AGGREGATE_SUCCESS,
        failureType: FETCH_AGGREGATE_FAILURE,
    },
    { initialData: {} }
);

export const fetchAggregateSelector = (state) => state.ratingReviews.fetchAggregate;
